module.exports = __webpack_public_path__ + "img/jmcd-ys-logo1.ce29393b.png";